var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGileadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 262.938,
    height: 30,
    viewBox: "0 0 262.938 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180253",
    "data-name": "Group 180253",
    transform: "translate(-2924 171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29562",
    "data-name": "Path 29562",
    d: "M8.319-.175a6.471,6.471,0,0,0,5.662-3.013l-1.816-.961A4.517,4.517,0,0,1,8.319-2.076a5.159,5.159,0,0,1-5.106-5.47,5.146,5.146,0,0,1,5.106-5.47,4.517,4.517,0,0,1,3.846,2.072l1.816-.961a6.444,6.444,0,0,0-5.662-3.013A7.136,7.136,0,0,0,1.012-7.546,7.136,7.136,0,0,0,8.319-.175Zm12.328,0A5.116,5.116,0,0,0,25.86-5.6a5.11,5.11,0,0,0-5.213-5.405A5.122,5.122,0,0,0,15.434-5.6,5.128,5.128,0,0,0,20.647-.175Zm0-1.709c-2.051,0-3.2-1.752-3.2-3.718,0-1.944,1.154-3.7,3.2-3.7,2.072,0,3.2,1.752,3.2,3.7C23.851-3.636,22.719-1.884,20.647-1.884ZM37.183-.431V-7.674c0-2.179-1.132-3.333-3.312-3.333A4.92,4.92,0,0,0,30.218-9.3V-10.75H28.3V-.431h1.923V-7.8A3.686,3.686,0,0,1,33.06-9.3c1.325,0,2.2.555,2.2,2.265v6.6Zm5.9.256a2.738,2.738,0,0,0,2.008-.662L44.6-2.29a1.479,1.479,0,0,1-1.047.406c-.662,0-1-.534-1-1.261V-9.063H44.64V-10.75H42.546v-2.82H40.623v2.82H38.914v1.688h1.709v6.345A2.245,2.245,0,0,0,43.08-.175ZM46.135-5.6A5.16,5.16,0,0,0,51.477-.175a5.8,5.8,0,0,0,4.145-1.538l-.9-1.261a4.387,4.387,0,0,1-3.055,1.218,3.384,3.384,0,0,1-3.5-3.2h8.162v-.47c0-3.162-1.923-5.576-5.021-5.576A5.19,5.19,0,0,0,46.135-5.6Zm5.17-3.824a3.053,3.053,0,0,1,3.141,3.077h-6.3A3.161,3.161,0,0,1,51.306-9.426ZM67.629-.431V-7.674c0-2.179-1.132-3.333-3.312-3.333A4.92,4.92,0,0,0,60.664-9.3V-10.75H58.741V-.431h1.923V-7.8a3.686,3.686,0,0,1,2.842-1.5c1.325,0,2.2.555,2.2,2.265v6.6Zm5.9.256a2.738,2.738,0,0,0,2.008-.662L75.043-2.29A1.479,1.479,0,0,1,74-1.884c-.662,0-1-.534-1-1.261V-9.063h2.094V-10.75H72.992v-2.82H71.069v2.82H69.36v1.688h1.709v6.345A2.245,2.245,0,0,0,73.526-.175ZM81.9-2.439A7.292,7.292,0,0,0,87.52-.175c3.846,0,5.384-2.072,5.384-4.294,0-3.034-2.713-3.76-5.042-4.38C86.089-9.3,84.55-9.7,84.55-10.985c0-1.2,1.09-2.008,2.671-2.008a5.559,5.559,0,0,1,4.124,1.666l1.239-1.581A6.986,6.986,0,0,0,87.392-14.9c-2.97,0-5.042,1.709-5.042,4.059C82.35-7.93,85-7.268,87.285-6.67c1.816.47,3.44.9,3.44,2.393,0,1.026-.812,2.2-3.119,2.2a6.009,6.009,0,0,1-4.487-2.008ZM97.839-.175a2.738,2.738,0,0,0,2.008-.662L99.356-2.29a1.479,1.479,0,0,1-1.047.406c-.662,0-1-.534-1-1.261V-9.063H99.4V-10.75H97.305v-2.82H95.382v2.82H93.673v1.688h1.709v6.345A2.245,2.245,0,0,0,97.839-.175Zm12.584-.256V-10.75H108.5v7.414a3.73,3.73,0,0,1-2.863,1.453c-1.325,0-2.179-.513-2.179-2.222V-10.75h-1.923v7.286c0,2.179,1.09,3.29,3.29,3.29A5.1,5.1,0,0,0,108.5-1.841v1.41Zm12.328,0V-14.682h-1.923v5.427a4.2,4.2,0,0,0-3.376-1.752c-2.692,0-4.615,2.115-4.615,5.427,0,3.376,1.923,5.405,4.615,5.405a4.268,4.268,0,0,0,3.376-1.731V-.431Zm-1.923-2.948a3.548,3.548,0,0,1-2.863,1.5c-1.923,0-3.119-1.56-3.119-3.7,0-2.158,1.2-3.718,3.119-3.718a3.566,3.566,0,0,1,2.863,1.517Zm5.94-9.1a1.222,1.222,0,0,0,1.239-1.218,1.24,1.24,0,0,0-1.239-1.239,1.254,1.254,0,0,0-1.239,1.239A1.236,1.236,0,0,0,126.768-12.481Zm.983,12.05V-10.75h-1.923V-.431Zm7.627.256A5.116,5.116,0,0,0,140.591-5.6a5.11,5.11,0,0,0-5.213-5.405A5.122,5.122,0,0,0,130.165-5.6,5.128,5.128,0,0,0,135.378-.175Zm0-1.709c-2.051,0-3.2-1.752-3.2-3.718,0-1.944,1.154-3.7,3.2-3.7,2.072,0,3.2,1.752,3.2,3.7C138.583-3.636,137.451-1.884,135.378-1.884Z",
    transform: "translate(3046.346 -148.15)",
    fill: "#c50f3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178752",
    "data-name": "Group 178752",
    transform: "translate(2955.128 -163.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29431",
    "data-name": "Path 29431",
    d: "M43.877,14.6v5.205a7.971,7.971,0,0,1-2.555.379c-3.5,0-5.678-1.987-5.678-5.205s2.177-5.205,5.773-5.205a8.335,8.335,0,0,1,3.407.568l.379.189.757-1.987-.379-.189A11.4,11.4,0,0,0,41.606,7.6c-5.962,0-8.707,3.785-8.707,7.382a6.73,6.73,0,0,0,2.177,5.205,8.083,8.083,0,0,0,5.962,2.177,13.592,13.592,0,0,0,5.11-.946h.189V14.6Z",
    transform: "translate(-32.892 -7.6)",
    fill: "#54565b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146469",
    "data-name": "Rectangle 146469",
    width: 2.555,
    height: 14.385,
    transform: "translate(17.988 0.284)",
    fill: "#54565b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29432",
    "data-name": "Path 29432",
    d: "M62.255,20.014V7.9H59.7V22.285h9.18V20.014Z",
    transform: "translate(-34.33 -7.616)",
    fill: "#54565b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29433",
    "data-name": "Path 29433",
    d: "M75.26,20.014V15.66H81.6V13.578H75.26v-3.6h6.814V7.9H72.8V22.285h9.558V20.014Z",
    transform: "translate(-35.033 -7.616)",
    fill: "#54565b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29434",
    "data-name": "Path 29434",
    d: "M92.519,10.739c.189.379,1.42,3.975,1.8,5.016h-3.88s1.893-4.637,2.082-5.016M93.844,7.9H91.289L85.8,22.285h2.555l1.609-4.259h5.11l1.609,4.259h2.745Z",
    transform: "translate(-35.73 -7.616)",
    fill: "#54565b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29435",
    "data-name": "Path 29435",
    d: "M114.946,9.587A10.817,10.817,0,0,0,108.132,7.6H103.4V9.777h4.732a7.815,7.815,0,0,1,4.921,1.42,5.135,5.135,0,0,1,1.325,3.407,5.267,5.267,0,0,1-1.514,3.975,7.511,7.511,0,0,1-5.11,1.609h-1.8V13.562H103.4v8.612h.189a26.643,26.643,0,0,0,3.88.189A11.472,11.472,0,0,0,114.851,20a6.936,6.936,0,0,0,2.177-5.394,7.091,7.091,0,0,0-2.082-5.016",
    transform: "translate(-36.673 -7.6)",
    fill: "#54565b",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178745",
    "data-name": "Group 178745",
    transform: "translate(2924 -171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29436",
    "data-name": "Path 29436",
    d: "M23.251,0h-.189C3.945,1.8,1.579,14.479,7.825,18.644c-1.136,4.637,0,4.637,0,4.637a21.426,21.426,0,0,1,.757-4.164C10.948,9.937,17.005,2.082,23.062.095h0c.189.095.189.095.189-.095",
    transform: "translate(-0.254)",
    fill: "#c51f3f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29437",
    "data-name": "Path 29437",
    d: "M21.767,3.389V3.2l-.189.189c-1.42,3.028-2.082,7.382-3.123,10.6-1.42,3.785-3.88,6.435-7.666,6.057V29.32S.662,24.872.662,17.679V4.241L8.9,3.484h0c.189,0,.189,0,.189-.189H0v14.29c0,8.139,10.789,12.587,10.789,12.587s10.978-4.637,10.978-12.492Z",
    transform: "translate(0 -0.172)",
    fill: "#c51f3f",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGileadIcon);
export default __webpack_public_path__ + "static/media/gileadIcon.a6b69de3f043363f922ca1192a8281dc.svg";
export { ForwardRef as ReactComponent };